import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useRef, useReducer } from 'react';
import { mapValues } from 'lodash';
import Container from "@scentregroup/ui/components/container";
import Heading from "@scentregroup/ui/components/heading";
import classNames from 'classnames';
import { useQueryParams, ArrayParam, StringParam } from 'use-query-params';
import WhatsOnList from '../../../components/whats-on-list';
import { WhatsOnSeeMoreContext } from '../../../context';
import Modules from '../../../components/modules';
import { getNowInCentreInDateFormat } from '../../../helpers/date-helpers';
import { rangesFromOccurrencesListsAndFilters, getOcccurrencesLists } from '../../../components/whats-on-list/contentful-to-ranges';
import WhatsHappeningFilters from '../../../components/whats-happening-filters';
import EventNotification from '../../../components/event-notification';
import { filterRanges, makeMultiFilterProps } from './helper';
import styles from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QUERY_NAME = {
  DATE_RANGE: 'range',
  CONTENT_TYPES: 'types',
  TOPICS: 'topics',
  EXPERIENCES: 'experiences'
};
const CONTENT_TYPES_FILTERS = ['Events', 'Offers'];
function reducer(state, action) {
  switch (action.type) {
    case 'expand_see_more':
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.range]: true
      });
    case 'collapse_see_more':
      if (action.range) {
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.range]: false
        });
      }
      return mapValues(state, _item => false);
    default:
      return _objectSpread({}, state);
  }
}
export function WhatsHappening(props) {
  var _template$analyticsMe;
  const {
    events,
    offers,
    centre,
    template,
    modules,
    topicFilters,
    experienceFilters
  } = props;
  const {
    0: state,
    1: dispatch
  } = useReducer(reducer, {});
  const [query, setQuery] = useQueryParams({
    range: StringParam,
    types: ArrayParam,
    topics: ArrayParam,
    experiences: ArrayParam
  });
  const {
    range: dateRange,
    types: contentTypes,
    topics,
    experiences
  } = query;
  const makeSetter = paramName => val => setQuery({
    [paramName]: val
  }, 'pushIn');
  const [setDateRange, setContentTypes, setTopics, setExperiences] = [QUERY_NAME.DATE_RANGE, QUERY_NAME.CONTENT_TYPES, QUERY_NAME.TOPICS, QUERY_NAME.EXPERIENCES].map(makeSetter);
  const onResetFilters = () => {
    dispatch({
      type: 'collapse_see_more'
    });
    return setQuery({}, 'push');
  };
  const {
    current: baseDate
  } = useRef(getNowInCentreInDateFormat(centre.timeZone));
  const {
    0: occurrencesLists
  } = useState(() => getOcccurrencesLists(baseDate, events, offers, centre));

  // Props for the filters
  const contentTypesProps = makeMultiFilterProps(contentTypes, setContentTypes, CONTENT_TYPES_FILTERS);
  const topicsProps = makeMultiFilterProps(topics, setTopics, topicFilters);
  const experiencesProps = makeMultiFilterProps(experiences, setExperiences, experienceFilters);
  const dateRangeProps = {
    baseDate,
    selectedDateRange: dateRange,
    onChange: setDateRange,
    dataTestId: 'date-range-filters'
  };

  // Values of selected filters to do the actual filtering
  const whatsOnContentId = 'whats-on-content';
  const whatsOnList = filterRanges(rangesFromOccurrencesListsAndFilters(baseDate, occurrencesLists, {
    contentTypes,
    experiences,
    topics,
    dateRange
  }), dateRange);
  const heading = "What's happening";
  return /*#__PURE__*/_jsxs(Container, {
    type: "large",
    className: classNames(styles.whatsHappeningContainer, styles.evolved),
    "data-id": "whats-happening_index_WhatsHappening_Container",
    children: [/*#__PURE__*/_jsx(Heading, {
      type: "medium",
      className: classNames(styles.whatsHappeningHeading, styles.whatsHappeningPageHeading),
      "data-id": "whats-happening_index_WhatsHappening_Container_Heading",
      children: heading
    }), /*#__PURE__*/_jsx(EventNotification, {
      className: styles.warningNotification,
      "data-id": "whats-happening_index_WhatsHappening_Container_EventNotification"
    }), /*#__PURE__*/_jsx(Modules, {
      modules: modules || [],
      "data-id": "whats-happening_index_WhatsHappening_Container_Modules"
    }), /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.whatsOn,
        "data-id": "whats-happening_index_WhatsHappening_div",
        children: [/*#__PURE__*/_jsx("div", {
          "aria-controls": whatsOnContentId,
          className: styles.whatsOnFilters,
          "data-id": "whats-happening_index_WhatsHappening_div_div_5",
          children: /*#__PURE__*/_jsx(WhatsHappeningFilters, {
            dateRangeProps,
            onResetFilters,
            contentTypesProps,
            topicsProps,
            experiencesProps,
            "data-id": "whats-happening_index_WhatsHappening_div_WhatsHappeningFilters"
          })
        }), /*#__PURE__*/_jsx(WhatsOnSeeMoreContext.Provider, {
          value: {
            state,
            dispatch
          },
          children: /*#__PURE__*/_jsx(WhatsOnList, {
            ranges: whatsOnList,
            analyticsDisplayId: template === null || template === void 0 || (_template$analyticsMe = template.analyticsMetadata) === null || _template$analyticsMe === void 0 ? void 0 : _template$analyticsMe.displayId,
            "data-id": "whats-happening_index_WhatsHappening_WhatsOnList"
          })
        })]
      })
    })]
  });
}
WhatsHappening.defaultPropTypes = {
  modules: []
};